export default {
    methods: {
        $hasNotification(type, id) {
            return this.$store.state.notifications.filter(notification => {
                return notification.data.type === type && notification.data.model_id === id;
            })
        },

        $notificationRead(notification) {
            this.$api('')
                .delete('unread-notifications/' + notification.id)
                .then(() => {
                    this.$store.dispatch('fetchUnreadNotifications');
                })
        }
    }
}